import request from "@/network/request"

// 查询微信公众号处方支付信息
export function queryDietaryguidance(data) {
  return request({
    url: "/api/app/advice/get",
    method: 'post',
    data,
  });
}

// 治疗膳食提交
export function dietTreatmentSave(data) {
  return request({
    url: "/hospitalordering/applet/diet/therapeuticDiet/submitOrderMultipleDays",
    method: 'post',
    data,
  });
}
// 治疗膳食详情
export function dietTreatmentDetails(data) {
  return request({
    url: "/hospitalordering/applet/diet/therapeuticDiet/index",
    method: 'post',
    data,
  });
}
// 治疗膳食收计费详情
export function dietTreatmentOrderDetails(data) {
  return request({
    url: "/hospitalordering/applet/order/payOrder/info",
    method: 'post',
    data,
  });
}
// 治疗膳食收计费下单
export function dietTreatmentOrderPay(data) {
  return request({
    url: "/hospitalordering/applet/order/payOrder/pay",
    method: 'post',
    data,
  });
}